import React from "react";
import { FastField } from "formik";
import classnames from 'classnames';
import moment from 'moment-timezone';
import Payment from 'payment';

export const InputFeedback = ({ error }) =>
    error ? <div className="input-feedback">{error}</div> : null;

export class TextInput extends React.Component {
    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched.topcis
        this.props.onBlur(this.props.id, true);
    };

    render() {
        const classes = classnames(
            "input-field",
            {
                "is-success": this.props.value || (!this.props.error && this.props.touched), // handle prefilled or user-filled
                "is-error": !!this.props.error && this.props.touched
            }
        );

        return (

            <div className={classes}>

                <label style={{ display: "block" }}>
                    {this.props.label}
                </label>

                <FastField name={this.props.id}
                    placeholder={this.props.placeholder}
                    type={this.props.type}

                    className={
                        this.props.error && this.props.touched ? (
                            'text-input error'
                        ) : (
                            'text-input'
                        )
                    } />
                {this.props.touched && <InputFeedback error={this.props.error} />}
            </div>
        );
    }
}

export class DOBTextInput extends React.Component {
    handleBlur = () => {
        let inputDate = this.props.value;
        if (moment(inputDate, "M/D/YYYY", true).isValid() || moment(inputDate, "M/D/YY", true).isValid() || moment(inputDate, "YYYY-MM-DD", true).isValid()) {
            let parsedDate = moment();
            if (moment(inputDate, "M/D/YYYY", true).isValid()) {
                parsedDate = moment(inputDate, "M/D/YYYY", true);
            }
            else if (moment(inputDate, "M/D/YY", true).isValid()) {
                parsedDate = moment(inputDate, "M/D/YY", true);
            }
            else {
                parsedDate = moment(inputDate, "YYYY-MM-DD", true);
            }
            if (parsedDate.clone().add(18, 'years').isAfter(moment())) {
                this.props.setFieldValue("showParentConf", true);
                this.props.onBlur(this.props.id, true);
            }
        }
        else {
            this.props.onBlur(this.props.id, true);

        }
    };

    render() {
        const classes = classnames(
            "input-field",
            {
                "is-success": this.props.value || (!this.props.error && this.props.touched), // handle prefilled or user-filled
                "is-error": !!this.props.error && this.props.touched
            }
        );
        return (

            <div className={classes}>
                <label style={{ display: "block" }}>
                    {this.props.label}
                </label>
                <input
                    id={this.props.id}
                    placeholder={this.props.placeholder}
                    type={this.props.type}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    onBlur={this.handleBlur}
                    className={
                        this.props.error && this.props.touched ? (
                            'text-input error'
                        ) : (
                            'text-input'
                        )
                    }
                />
                {this.props.touched && <InputFeedback error={this.props.error} />}
            </div>
        );
    }
}

export class CCTextInput extends React.Component {
    handleBlur = () => {
        // this is going to call setFieldTouched and manually update touched.topics
        this.props.onBlur(this.props.id, true);
    };

    handleChange = e => {
        if (this.props.CCField === "number") {
            this.props.onChange(this.props.id, Payment.fns.formatCardNumber(e.target.value));
        }
        else if (this.props.CCField === "expiry") {
            if (e.target.value.length > 2 && e.target.value.length < 4) {
                let first = "";
                if (e.target.value.slice(2, 3) === "/") {
                    first = e.target.value.slice(0, 2) + " / ";

                }
                else {
                    first = e.target.value.slice(0, 2) + " / " + e.target.value.slice(2, 3);

                }
                this.props.onChange(this.props.id, first.replace(/[^0-9\s//]/gi, ''));
            }
            else if (e.target.value.length > 4 && e.target.value.length <= 5) {
                let first = e.target.value.slice(0, 2);
                this.props.onChange(this.props.id, first.replace(/[^0-9\s//]/gi, ''));
            }
            else if (e.target.value.length > 9) {
                this.props.onChange(this.props.id, e.target.value.slice(0, 9).replace(/[^0-9\s//]/gi, ''));
            }
            else {
                this.props.onChange(this.props.id, e.target.value.replace(/[^0-9\s//]/gi, ''));

            }
        }
        else if (this.props.CCField === "cvc") {
            if (e.target.value.length > 4) {
                this.props.onChange(this.props.id, e.target.value.slice(0, 4));
            }
            else {
                this.props.onChange(this.props.id, e.target.value);
            }
        }
        else {
            // this is going to call setFieldValue and manually update values.
            this.props.onChange(this.props.id, e.target.value);
        }
        this.props.onChange("focused", this.props.CCField);

    };
    render() {
        const classes = classnames(
            "input-field",
            {
                "is-success": this.props.value || (!this.props.error && this.props.touched), // handle prefilled or user-filled
                "is-error": !!this.props.error && this.props.touched
            }
        );

        return (

            <div className={classes}>

                <label style={{ display: "block" }}>
                    {this.props.label}
                </label>
                <input
                    name={this.props.id}
                    id={this.props.id}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    className={
                        this.props.error && this.props.touched ? (
                            'text-input error'
                        ) : (
                            'text-input'
                        )
                    }
                />
                {this.props.touched && <InputFeedback error={this.props.error} />}
            </div>
        );
    }
}

export const Checkbox = ({
    field: { name, value, onChange, onBlur },
    form: { errors, touched, setFieldValue },
    id,
    label,
    className,
    ...props
}) => {
    return (
        <div>
            <input
                name={name}
                id={id}
                type="checkbox"
                value={props.value}
                checked={props.value}
                onChange={onChange}
                onBlur={onBlur}
                className={classnames("radio-button")}
            />
            <label htmlFor={id}>I understand that there are <strong className="error">no refunds for road tests</strong> and tests <strong className="error">  can not be rescheduled within 14 days </strong>of the date requested, and that the test could be Saturday or Monday.</label>
            {touched[name] && <InputFeedback error={errors[name]} />}
        </div>
    );
};

export const addCompletionCertificateCheckBox = ({
    field: { name, value, onChange, onBlur },
    form: { errors, touched, setFieldValue },
    id,
    label,
    className,
    ...props
}) => {
    return (
        <div>
            <label htmlFor={id}>Pay for Driver's Education Completion Ceritification<br></br>(Only for <strong className="error">Parkway students taking teen driver ed program</strong>)</label>

            <input
                name={name}
                id={id}
                type="checkbox"
                value={props.value}
                checked={props.value}
                onChange={onChange}
                onBlur={onBlur}
                className={classnames("radio-button")}
            />
            <label htmlFor={id}>Add Driver's Education Completion Certification Fee (+$25)</label>
            <label htmlFor={id}>This certification only needs to be purchased once. If you have previously paid for your driver's ed certification do not repurchase.</label>
            {touched[name] && <InputFeedback error={errors[name]} />}
        </div>
    );
};

// Radio group
export const RadioButtonGroup = ({
    value,
    error,
    touched,
    label,
    className,
    children,
    sublabel
}) => {
    const classes = classnames(
        "input-field",
        {
            "is-success": value || (!error && touched), // handle prefilled or user-filled
            "is-error": !!error
        },
        className
    );
    return (
        <div className={classes}>
            <fieldset>
                <legend>{label}</legend>
                <label className="error">{sublabel}</label>
                {children}
                {touched && <InputFeedback error={error} />}
            </fieldset>
        </div>
    );
};
